import { Checkbox } from 'antd';
import type { CheckboxProps, CheckboxRef } from 'antd';
import { forwardRef } from 'react';
import { CONTROL_CLASS } from '@/theme/controlSizing';

/**
 * Props {@link CheckBox}. Inherits `CheckboxProps` Antd.
 *
 * (Catatan: nama komponen `CheckBox` — beda kapitalisasi dari `Checkbox` Antd
 * supaya dapat di-import berdampingan kalau perlu. Tapi praktisnya cukup pakai
 * `CheckBox` ini saja.)
 */
export type CheckBoxProps = CheckboxProps;

/**
 * Checkbox — wrapper `Antd Checkbox`.
 *
 * Sifat universal:
 * - Class `booku-control` → vertical center alignment dengan label di sebelahnya.
 * - Tidak ada prop `context` karena Antd Checkbox tidak punya `size` —
 *   tinggi sudah konsisten via theme token.
 *
 * Pemakaian:
 * ```tsx
 * <CheckBox checked={aktif} onChange={(e) => setAktif(e.target.checked)}>
 *   Aktifkan fitur
 * </CheckBox>
 * ```
 *
 * Untuk Checkbox.Group (multiple checkboxes), pakai {@link CheckBoxGroup}.
 *
 * Dokumentasi pattern: `.claude/docs/Booku v2/ui-patterns/control-system-pattern.md`
 */
export const CheckBox = forwardRef<CheckboxRef, CheckBoxProps>(
  function CheckBox({ className, ...rest }, ref) {
    return (
      <Checkbox
        ref={ref}
        className={`${CONTROL_CLASS}${className ? ` ${className}` : ''}`}
        {...rest}
      />
    );
  }
);

// Re-export Checkbox.Group untuk konsistensi import.
export const CheckBoxGroup = Checkbox.Group;
